import Controller from '@ember/controller';
import { beebeeAjaxPost, beebeeAjaxGet } from 'beebee-base/lib/utility';
import { set } from '@ember/object';

import { inject as iController } from '@ember/controller';
import { inject as iService } from '@ember/service';
import { task } from 'ember-concurrency';

import getConfig from 'beebee-base/lib/get-config';
export default class ConfirmController extends Controller {
  @iController('application') applicationController;
  @iService session;

  queryParams = ['event_id'];
  notFound = false;

  @(task(function* () {
    set(this, 'actionDone', null);
    set(this, 'notFound', null);
    set(this, 'information', null);

    try {
      let event = yield beebeeAjaxGet(`${getConfig(this).APP.urlApi}/confirm_event`, this.session.token, {
        event_id: this.event_id,
      });

      if (event?.information) {
        event.information.alreadyConfirmed = [1000, 1001].includes(
          event.information.event_status_id
        );
        set(this, 'information', event.information);
      } else {
        set(this, 'notFound', true);
      }
    } catch (e) {
      set(this, 'notFound', true);
    }
  }).drop())
  loadDataTask;

  @(task(function* (action = false) {
    yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/confirm_event`, this.session.token, {
      event_id: this.event_id,
      action: action,
      token: this.session.token,
    });

    set(this, 'actionDone', {
      action: action,
    });
  }).drop())
  sendAnswerTask;
}
